import { request } from '@/utils/request'
const StationManageService = {
  state: {},

  mutations: {},

  actions: {
    // 区域分页
    getregion({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.get('SystemManage/Area/GetAllArea', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 保存区域
    Saveregion({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/Area/SubmitForm?keyValue=' + params.keyValue, params.formData).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 删除区域
    Deleteregion({ commit }, params) {
      return new Promise((resolve, reject) => {
        request.post('SystemManage/Area/DeleteForm', params).then(response => {
          resolve(response)
        }).catch(error => {
          reject(error)
        })
      })
    }
  }
}
export default StationManageService
